module.exports = __webpack_public_path__ + "static/media/error.ce710465.mp3";